import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, FormControlLabel, Checkbox } from '@mui/material'
import { Row, Col, Form } from 'react-bootstrap';
import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';

export default function Notification(props) {
  const [noticeIndex, setNoticeIndex] = useState(0);
  const [noticeDialog, setNoticeDialog] = useState(false);

  let navigate = useNavigate()
  let singleItem = props.singleItem
  let publishDate = new Date(props?.notices[noticeIndex]?.published_on * 1000)
  let publishDateFormatted = `${publishDate.toLocaleString("en-GB", { day: "numeric" })} ${publishDate.toLocaleString("en-GB", { month: "long" })} ${publishDate.toLocaleString("en-GB", { year: "numeric" })}`


  useEffect(() => {
    let timeNow = Math.floor(Date.now() / 1000)

    if (!singleItem && props?.showPath === props?.currentPath) {
      if (props?.notices.length > 0) {
        if(props.settings){
          if(timeNow >= props?.settings?.lastReminder && timeNow >= props?.settings?.nextReminder){
            setNoticeIndex(0)
            setNoticeDialog(true)
          }
        }
      }
      else setNoticeDialog(false)
    }
  }, [props.currentPath, props?.notices.length])

  // notification changes

  const handleNext = () => {
    let index = noticeIndex
    if (index + 1 < props?.notices.length) {
      setNoticeIndex(index + 1)
    }
  }

  const handlePrev = () => {
    let index = noticeIndex
    if (index - 1 > -1) {
      setNoticeIndex(index - 1)
    }
  }

  const checkLoadingArray = () => {
    if (props.notices.length > noticeIndex && props?.loadingArray) {
      if (props?.loadingArray.includes(props?.notices[noticeIndex].id)) {
        return true
      }
      else return false
    }
    else return false
  }

  return (
    <Dialog
      open={singleItem ? props.dialogOpen : noticeDialog}
      maxWidth='md'
      fullWidth={true}
      className='notification-dialog'
    >
      <DialogTitle className='notification-dialog-title'>
        <span>
          Notices
        </span>
        {!singleItem &&
          <div className='notification-nav'>
            <Button
              variant='contained'
              disabled={noticeIndex === 0}
              color='primary'
              size='small'
              onClick={() => {
                handlePrev()
              }}
            >
              <ChevronLeftRounded />
            </Button>
            {noticeIndex + 1} of {props?.notices.length} unread
            <Button
              variant='contained'
              disabled={noticeIndex + 1 >= props?.notices.length}
              color='primary'
              size='small'
              onClick={() => {
                handleNext()
              }}
            >
              <ChevronRightRounded />
            </Button>
          </div>
        }
        <Button
          className='cancel-btn'
          variant='outlined'
          onClick={() => {
            if (singleItem && props.dialogClose) {
              props.dialogClose()
            }
            if (props.settings && props.forceNextReminder) {
              props.forceNextReminder()
              setNoticeDialog(false)
            }
            else {
              setNoticeDialog(false)
            }
          }}
        >
          Cancel
        </Button>
      </DialogTitle>
      <DialogContent className='notification-dialog-content'>
        <div className='notification-content-heading'>
          <div className='notification-content-date'>{publishDateFormatted}</div>
          <div className='notification-checkbox-container'>
            <FormControlLabel
              className='notification-checkbox-form-control'
              label="I've read this notice"
              control={
                <>
                  {checkLoadingArray() ?
                    <CircularProgress
                      color='primary'
                      sx={{
                        width: '20px !important',
                        height: '20px !important',
                        margin: '5px'
                      }}
                    />
                    :
                    <Checkbox
                      className='notification-checkbox'
                      checked={singleItem ? props.readStatus : props?.notices[noticeIndex]?.isRead}
                      onChange={(e) => {
                        if (props?.statusChange) {
                          props.statusChange(props?.notices[noticeIndex].id, e.target.checked)
                        }
                      }}
                    />
                  }
                </>
              }
            />
          </div>
        </div>
        <div className='notification-content-container'>
          <div className='notification-content-title'>
            {props?.notices[noticeIndex]?.label}
          </div>
          <div className='notification-content-body'>
            <div dangerouslySetInnerHTML={{ __html: props?.notices[noticeIndex]?.content }} />
          </div>
        </div>
      </DialogContent>
      {!singleItem &&
        <DialogActions className='notification-dialog-actions'>
          <Button
            variant='text'
            onClick={() => {
              setNoticeDialog(false)
              if (props.settings && props.forceNextReminder) {
                props.forceNextReminder()
              }
              navigate('/account/notices')
            }}
          >
            Go to notice archive
          </Button>
          <Button
            variant='text'
            onClick={() => {
              props?.markAllNotifications()
            }}
          >
            Mark all notices as read
          </Button>
        </DialogActions>
      }
    </Dialog>
  )
}